<template>
    <div class="site-owner">
        <div class="paca-group">
            <div class="paca-group-list" :class="`list-${index}`" v-for="(item ,index) in siteOwnerList" :key="index" :name="item.id == '' ? 'undefind' : item.id">
                <div class="paca-group-list__header" @click="itemCollapse(index)">
                    <i class="paca-group-list__header-icon"></i>
                    <span class="paca-group-list__header-text">
                        <span class="paca-group-list__header-text-nickname">{{item.nickname}}</span>
                        <span class="paca-group-list__header-text-email">({{item.email}})</span>
                        <span class="paca-group-list__header-text-length">{{item.sites_info.length}}</span>
                    </span>
                </div>
                <div class="paca-group-list__content">
                    <div class="site-owner-list-email">
                        <div class="site-owner-list-email-label">Email</div>
                        <div class="site-owner-list-email-value">{{item.email}}</div>
                    </div>
                    <div class="paca-table">
                        <div class="paca-table__header">
                            <div class="paca-table__header-item item-column column-name">場站名稱({{item.sites_info.length}})</div>
                            <div class="paca-table__header-item item-column column-site">場站代碼</div>
                        </div>
                        <div class="paca-table__body">
                            <div class="paca-table__body-col" v-for="(siteItem, siteIndex) in item.sites_info" :key="siteIndex">
                                <div class="paca-table__body-col-list">
                                    <div class="paca-table__body-col-list-item item-column column-site">{{siteItem.name}}</div>
                                    <div class="paca-table__body-col-list-item item-column column-name">{{siteItem.site}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as api from '@/script/apiService/api.js'
export default {
    name: "siteOwner",
    data(){
        return{
            siteOwnerList: []
        }
    },
    methods: {
        itemCollapse(index){
            if(document.querySelector(`.list-${index}`).classList.contains("is-active")){
                document.querySelector(`.list-${index}`).classList.remove("is-active");
            }else{
                if(document.querySelector(".is-active")){
                    document.querySelector(".is-active").classList.remove("is-active");
                }
                document.querySelector(`.list-${index}`).classList.add("is-active");
            }
        },
        async getAdminSiteOwnerList(){
            return await api.getAdminSiteOwnerList()
        }
    },
    async activated(){
        let res = await this.getAdminSiteOwnerList();
        if(!res.error_statis){
            res.forEach(function(item){
                item.sites_info.sort(function(a, b){
                    if(a.site.length > 7){
                        return 1;
                    }else if(a.site > b.site){
                        return 1;
                    } else if (a.site < b.site){
                        return -1;
                    } else {
                        return 0;
                    }
                })
            })
            this.siteOwnerList = res;
        }
    }
}
</script>